var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showValue)?_c('div',{staticClass:"markdown-argument"},[_c('ClampedText',[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])])],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }